import { type IAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/IAdvancedRichText.ts';
import { type IAssignableExpression } from '@framework/engine/schema/expressions/repository/assignable/IAssignableExpression.ts';
import { type IInputWidget } from '@framework/engine/schema/widgets/repository/inputs/IInputWidget.ts';
import { type WidgetType } from '@framework/engine/schema/widgets/Widget.ts';

export const WidgetProvinceType = 'province' as WidgetType.Province;

/**
 * Interfaccia Download Widget
 */
export interface IProvinceWidget extends IInputWidget {
  id: string;
  type: WidgetType.Province;
  // label?: IAdvancedRichText;
  provinceLabel?: IAdvancedRichText;
  townLabel?: IAdvancedRichText;
  provincePlaceholder?: string | null;
  townPlaceholder?: string | null;
  provinceHelpText?: IAdvancedRichText;
  townHelpText?: IAdvancedRichText;

  // Gestiamo i campi di default del widget
  // con un sistema custom, slegato dal normale "defaultValue"
  // degli InputWidget
  defaultProvince?: IAssignableExpression;
  defaultTown?: IAssignableExpression;

  municipalityGroupList?: string[] | null;
}
